// @ts-nocheck
// This file is auto-generated by GraphQL Code Generator

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type Agent = {
  __typename?: 'Agent';
  createdAt: Scalars['DateTime']['output'];
  cron: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Last time a cron tick queued a processor run for this agent */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** JSON object passed as processor variables when the agent runs (e.g. optional allowlisted model for agent-edit-document) */
  parameters: Scalars['JSON']['output'];
  processorId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type AiAuditFilterOptions = {
  __typename?: 'AiAuditFilterOptions';
  /** Distinct OpenAI API pathnames (e.g. /v1/chat/completions) */
  endpoints: Array<Scalars['String']['output']>;
  /** Distinct non-null audit processor ids (metadata.processorId; includes legacy metadata.prompt) */
  processorIds: Array<Scalars['String']['output']>;
};

export type AiAuditSummary = {
  __typename?: 'AiAuditSummary';
  /** When the audit row was created */
  createdAt: Scalars['DateTime']['output'];
  /** OpenAI request pathname (e.g. /v1/chat/completions) */
  endpoint: Scalars['String']['output'];
  /** CUID of the audit row */
  id: Scalars['String']['output'];
  /** Correlates audit rows from one executeProcessor run (from metadata.instanceId) */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** Iteration index when provided (from metadata.iteration) */
  iteration?: Maybe<Scalars['Int']['output']>;
  /** Max iterations when provided (from metadata.maxIterations) */
  maxIterations?: Maybe<Scalars['Int']['output']>;
  /** Normalized request metadata snapshot (processorId, instanceId, model, …) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Model id when provided (from metadata.model) */
  model?: Maybe<Scalars['String']['output']>;
  /** Audit correlation id when provided (metadata.processorId, else legacy metadata.prompt) */
  processorId?: Maybe<Scalars['String']['output']>;
  /** Reported input-side token count from metadata after a successful call (from metadata.tokenIn); absent on failures or older rows */
  tokenIn?: Maybe<Scalars['Int']['output']>;
  /** Reported output-side token count from metadata when present (from metadata.tokenOut); often absent for embeddings */
  tokenOut?: Maybe<Scalars['Int']['output']>;
};

export type AppSettings = {
  __typename?: 'AppSettings';
  /** OpenAI model IDs allowed for document AI chat completions (user preference, implicit processor defaults, allowlisted explicit overrides such as agent-edit-document parameters.model). */
  aiAssistEditChatModels: Array<Scalars['String']['output']>;
  /** Deployment default when the user has not set a preference; also used when a processor omits model or sends a non-allowlisted id on a chat completion. */
  defaultAiAssistEditChatModel: Scalars['String']['output'];
  /** Regex pattern for valid document paths (lowercase a-z, digits, /, -, (, )) */
  documentPathRegex: Scalars['String']['output'];
  localDatabase?: Maybe<Scalars['Boolean']['output']>;
  localEndpoints?: Maybe<Scalars['Boolean']['output']>;
  localGraphqlTaskSimulator?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  /** Logged-in user */
  user: AuthUser;
};

export type AuthUser = {
  __typename?: 'AuthUser';
  /** When set on the JWT (`assumed-by`), the user id acting on behalf of the subject (e.g. system for queued processors) */
  assumedByUserId?: Maybe<Scalars['String']['output']>;
  /** User display name */
  displayName: Scalars['String']['output'];
  /** Resolved model id: user preference when valid, else deployment default. */
  effectiveAiAssistEditChatModel: Scalars['String']['output'];
  /** User email */
  email: Scalars['String']['output'];
  /** User ID */
  id: Scalars['String']['output'];
  /** Persisted JSON settings (subset exposed here) */
  settings?: Maybe<UserSettings>;
  /** Optional unique user name */
  userName?: Maybe<Scalars['String']['output']>;
};

export type CreateAiThreadReplyInput = {
  /** Optional ProcessorInstance id to attach as message context (must belong to current user) */
  processorInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Thread root message ID */
  rootMessageId: Scalars['String']['input'];
  /** Assistant reply body */
  value: Scalars['String']['input'];
};

export type CreateMessageInput = {
  /** Context key-value pairs to attach to the message */
  contexts?: InputMaybe<Array<MessageContextInput>>;
  /** Parent message ID for threading */
  parentMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Content of the message */
  value: Scalars['String']['input'];
};

export type CreateReactionInput = {
  /** Stable reaction key (Slack-style), e.g. joy, thumbsup */
  id: Scalars['String']['input'];
  /** Display emoji for this reaction */
  value: Scalars['String']['input'];
};

export type CreateUserSecretInput = {
  /** Optional label (max 500 chars) */
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  /** Plaintext; server encrypts before storage */
  plaintextValue: Scalars['String']['input'];
};

export type DeleteAgentResponse = {
  __typename?: 'DeleteAgentResponse';
  deleted: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DeleteMessageInput = {
  /** ID of the message to soft-delete */
  id: Scalars['String']['input'];
};

export type DeletePromptInput = {
  /** ID of the prompt to delete */
  id: Scalars['String']['input'];
};

export type DeletePromptResponse = {
  __typename?: 'DeletePromptResponse';
  /** Response message */
  message: Scalars['String']['output'];
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type Document = {
  __typename?: 'Document';
  /** Child documents whose path starts with this document path (paginated, sorted alphabetically) */
  children: DocumentChildrenResponse;
  /** Context of the document */
  context?: Maybe<Scalars['String']['output']>;
  /** When the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** History of changes to this document */
  documentHistory: Array<DocumentHistory>;
  /** Format of the document */
  format?: Maybe<Scalars['String']['output']>;
  /** Structured format-specific metadata (for example markdown block sidecar state). */
  formatMetadata?: Maybe<Scalars['JSON']['output']>;
  /** Format validation information for the document */
  formatValidation?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the document (random ID) */
  id: Scalars['String']['output'];
  /** Closest parent document: the document whose path is the longest prefix of this document path (e.g. for path "a/b/c" returns document at "a/b" if it exists, else "a") */
  parent?: Maybe<Document>;
  /** Path/name of the document (used for lookups) */
  path: Scalars['String']['output'];
  /** When the document was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID who created the document */
  userId: Scalars['String']['output'];
  /** Content of the document */
  value: Scalars['String']['output'];
};


export type DocumentChildrenArgs = {
  input?: InputMaybe<DocumentChildrenPaginationInput>;
};

export type DocumentChildrenPaginationInput = {
  /** Cursor for pagination (path of last item from previous page) */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of child documents to return (default: 5) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentChildrenResponse = {
  __typename?: 'DocumentChildrenResponse';
  /** Child documents whose path starts with the parent path */
  items: Array<Document>;
  /** Pagination metadata */
  pagination: PaginationInfo;
};

export type DocumentHistory = {
  __typename?: 'DocumentHistory';
  /** Resolved user for display (matches message author shape) */
  changedBy?: Maybe<MessageAuthor>;
  /** User id who created this revision (null for legacy rows) */
  changedByUserId?: Maybe<Scalars['String']['output']>;
  /** When the revision was created */
  createdAt: Scalars['DateTime']['output'];
  /** The document this revision belongs to */
  document?: Maybe<Document>;
  /** Document ID this revision belongs to */
  documentId: Scalars['String']['output'];
  /** Unique identifier for the document history entry */
  id: Scalars['String']['output'];
  /** JSON value containing the full document record (excluding id, createdAt, updatedAt) and source information. Structure: { value: { userId: string, context: string | null, value: string, format: string | null, formatMetadata: JSON | null, formatValidation: string | null }, source: [{ type: string, id: string }] } */
  value: Scalars['JSON']['output'];
};

export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  editTimestamp: Scalars['Float']['output'];
};

export type DocumentNotFound = {
  __typename?: 'DocumentNotFound';
  /** Child documents whose path starts with this path (same as Document.children) */
  children: DocumentChildrenResponse;
  /** Closest parent document whose path is a prefix of this path (same as Document.parent) */
  parent?: Maybe<Document>;
  /** The path that was requested but no document exists (e.g. from documentByPath); null when resolved from document(id) not found */
  path?: Maybe<Scalars['String']['output']>;
};


export type DocumentNotFoundChildrenArgs = {
  input?: InputMaybe<DocumentChildrenPaginationInput>;
};

export type DocumentResult = Document | DocumentNotFound;

export type DocumentUpdatedPayload = {
  __typename?: 'DocumentUpdatedPayload';
  documentId: Scalars['ID']['output'];
  editTimestamp: Scalars['Float']['output'];
  ownerUserId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExecuteAgentCronInput = {
  /** Anchor time for the 15-minute evaluation window (UTC). Omitted or null uses server time. Window is [align15(anchor), align15(anchor)+15m). */
  scheduledTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExecuteAgentCronResponse = {
  __typename?: 'ExecuteAgentCronResponse';
  agentsEvaluated: Scalars['Int']['output'];
  agentsQueued: Scalars['Int']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  queuedAgentIds: Array<Scalars['String']['output']>;
};

export type ExecuteProcessorInput = {
  /** ID of the processor to run */
  processorId: Scalars['String']['input'];
  /** Deferred run only: reuse this ProcessorInstance row (created by queueExecuteProcessor with status QUEUED until execution starts). */
  processorInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Map of input variables passed to the processor as ctx.variables */
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExecuteProcessorResponse = {
  __typename?: 'ExecuteProcessorResponse';
  /** Error message when success is false */
  error?: Maybe<Scalars['String']['output']>;
  /** Id of the ProcessorInstance row for this run (present when a row was created, including on failure) */
  instanceId?: Maybe<Scalars['String']['output']>;
  /** JSON result from the processor when success is true */
  result?: Maybe<Scalars['JSON']['output']>;
  /** Whether the execution succeeded */
  success: Scalars['Boolean']['output'];
};

export type GeneratePromptTemplateInput = {
  /** Optional document ID for context */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Optional message ID for context */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** Prompt ID to use as template string */
  promptId: Scalars['String']['input'];
};

export type GeneratePromptTemplatesInput = {
  /** Array of prompt template inputs to process */
  templates: Array<GeneratePromptTemplateInput>;
};

export type GenerateTemplateInput = {
  /** Optional document ID for context */
  documentId?: InputMaybe<Scalars['String']['input']>;
  /** Optional message ID for context */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** Template string to render */
  templateString: Scalars['String']['input'];
};

export type GenerateTemplateResponse = {
  __typename?: 'GenerateTemplateResponse';
  /** Error message if template generation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Generated template result */
  result: Scalars['String']['output'];
  /** Whether the template generation was successful */
  success: Scalars['Boolean']['output'];
};

export type GenerateTemplatesInput = {
  /** Array of template inputs to process */
  templates: Array<GenerateTemplateInput>;
};

export type GenerateTemplatesResponse = {
  __typename?: 'GenerateTemplatesResponse';
  /** Array of template generation results */
  results: Array<GenerateTemplateResponse>;
};

export type GetAgentsResponse = {
  __typename?: 'GetAgentsResponse';
  agents: Array<Agent>;
};

export type GetProcessorsResponse = {
  __typename?: 'GetProcessorsResponse';
  /** List of processors */
  processors: Array<Processor>;
};

export type GetPromptsResponse = {
  __typename?: 'GetPromptsResponse';
  /** List of prompt definitions */
  prompts: Array<PromptDefinition>;
};

/** Outcome of a Gmail API probe using a stored OAuth connection */
export type GmailConnectionTestResult = {
  __typename?: 'GmailConnectionTestResult';
  /** Human-readable error when success is false */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Number of messages summarized in subjects */
  fetchedCount: Scalars['Int']['output'];
  /** Gmail list API resultSizeEstimate when provided */
  resultSizeEstimate?: Maybe<Scalars['Int']['output']>;
  /** Subject lines for a small inbox sample (no bodies) */
  subjects: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LoginInput = {
  /** User email */
  email: Scalars['String']['input'];
  /** Password */
  password: Scalars['String']['input'];
};

export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** Whether logout succeeded */
  success: Scalars['Boolean']['output'];
};

export type MentionUser = {
  __typename?: 'MentionUser';
  /** Display name shown as secondary text */
  displayName: Scalars['String']['output'];
  /** User ID */
  id: Scalars['String']['output'];
  /** Unique username used for mentions */
  userName: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  /** Author of the message (subquery User for display name) */
  author: MessageAuthor;
  /** Child messages (replies) under this message */
  childMessages: Array<Message>;
  /** When the message was created */
  createdAt: Scalars['DateTime']['output'];
  /** When the message was soft-deleted; null if still visible */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the message */
  id: Scalars['String']['output'];
  /** Context data associated with this message */
  messageContexts: Array<MessageContext>;
  /** Parent message ID for threading */
  parentMessageId?: Maybe<Scalars['String']['output']>;
  /** Map of reaction id to user ids who reacted: { [reactionId: string]: string[] } */
  reactions: Scalars['JSON']['output'];
  /** Source type of the message (audio, message, etc.) */
  source: Scalars['String']['output'];
  /** Optional source ID for the message */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** User ID the message is targeted at */
  targetUserId: Scalars['String']['output'];
  /** When the message was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User ID who created the message */
  userId: Scalars['String']['output'];
  /** Content of the message */
  value: Scalars['String']['output'];
};

export type MessageAuthor = {
  __typename?: 'MessageAuthor';
  /** Display name of the message author */
  displayName: Scalars['String']['output'];
  /** MD5 hex digest of the author email (trimmed, lowercased) for Gravatar URLs, or the literal "system" for the built-in system user (clients may substitute app branding) */
  gravatarHash: Scalars['String']['output'];
};

export type MessageContext = {
  __typename?: 'MessageContext';
  /** Resolved document when name is "documentId"; null otherwise */
  document?: Maybe<Document>;
  /** Message ID this context belongs to */
  messageId: Scalars['String']['output'];
  /** Name of the context */
  name: Scalars['String']['output'];
  /** Resolved processor run when name is "processorInstanceId"; null otherwise */
  processorInstance?: Maybe<ProcessorInstance>;
  /** Value of the context */
  value: Scalars['String']['output'];
};

export type MessageContextInput = {
  /** Name of the context */
  name: Scalars['String']['input'];
  /** Value of the context */
  value: Scalars['String']['input'];
};

export enum MessageReactionOperation {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type MessageReactionReactor = {
  __typename?: 'MessageReactionReactor';
  /** Reactor display name when available, else fallback user id */
  displayName: Scalars['String']['output'];
  /** MD5 hash for Gravatar image when available */
  gravatarHash?: Maybe<Scalars['String']['output']>;
  /** User ID of the reactor */
  userId: Scalars['String']['output'];
};

export type MessageThreadUpdatedPayload = {
  __typename?: 'MessageThreadUpdatedPayload';
  participantUserIds: Array<Scalars['ID']['output']>;
  threadRootId: Scalars['ID']['output'];
};

export type MessagesQueryInput = {
  /** Return only messages that have ALL matching context name/value pairs */
  contextFilters?: InputMaybe<Array<MessageContextInput>>;
  /** Exclude root messages that have any message context whose name is in this list (e.g. aiAuditId, documentId). Omit or empty for no exclusion. */
  excludeContextNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Start date for filtering messages (inclusive) */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date for filtering messages (inclusive) */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAiThreadReply: Message;
  createMessage: Message;
  /** Create a reaction definition (id → emoji) */
  createReaction: Reaction;
  createUserSecret: UserSecret;
  deleteAgent: DeleteAgentResponse;
  deleteMessage: Message;
  /** Remove an OAuth connection owned by the signed-in user */
  deleteOAuthConnection: Scalars['Boolean']['output'];
  deletePrompt: DeletePromptResponse;
  /** Delete a reaction definition by id (hard delete) */
  deleteReaction: Scalars['Boolean']['output'];
  /** Soft-delete an upload (sets deletedAt). Returns false if not found or already deleted. */
  deleteUpload: Scalars['Boolean']['output'];
  /** Delete a user secret owned by the signed-in user */
  deleteUserSecret: Scalars['Boolean']['output'];
  /** Invoked by Cloud Scheduler (~every 15m). Evaluates enabled agents whose cron falls in the current UTC window and queues executeProcessor per user. Requires X-Scheduler-Secret. */
  executeAgentCron: ExecuteAgentCronResponse;
  executeProcessor: ExecuteProcessorResponse;
  generatePromptTemplates: GenerateTemplatesResponse;
  generateTemplates: GenerateTemplatesResponse;
  /** Login with email and password. Sets an httpOnly cookie with JWT. */
  login: AuthPayload;
  /** Clear the auth cookie (logout). */
  logout: LogoutPayload;
  /** Deferred handler for message reaction changes (queued from toggleMessageReaction). */
  processMessageReaction: ProcessMessageReactionResponse;
  /** Queue executeProcessor for asynchronous HTTP execution (Cloud Tasks or GRAPHQL_TASK_SIMULATOR_URL). A short-lived JWT (subject = caller, `assumed-by` = system) is sent on the deferred request. */
  queueExecuteProcessor: QueueExecuteProcessorResponse;
  /** Exchange refresh cookie for a new access JWT. No auth required. Rotates refresh token. */
  refreshAccessToken: AuthPayload;
  /** Register with email and password. Auto-logs in and sets cookie. */
  register: AuthPayload;
  /** Rename an upload (display filename only; storage key unchanged). */
  renameUpload: UserUpload;
  /** Queues executeProcessor for this agent via the same deferred HTTP path as executeAgentCron (Cloud Tasks or GRAPHQL_TASK_SIMULATOR_URL). A JWT with `assumed-by` = system is sent on the worker request. */
  runAgent: RunAgentResponse;
  /** Call Gmail using the stored refresh token for a connection you own (read-only preview) */
  testGmailConnection: GmailConnectionTestResult;
  toggleMessageReaction: Message;
  transcribeAudio: TranscribeAudioResponse;
  updateMessage: Message;
  /** Merge and persist the current user JSON settings (e.g. AI model). */
  updateMyUserSettings: AuthUser;
  /** Update the description label for an OAuth connection you own */
  updateOAuthConnection: UserOAuthConnection;
  /** Update current user profile fields (e.g. display name). */
  updateUserProfile: AuthUser;
  updateUserSecret: UserSecret;
  upsertAgent: UpsertAgentResponse;
  upsertDocument: UpsertDocumentResponse;
  upsertProcessor: UpsertProcessorResponse;
  upsertPrompt: UpsertPromptResponse;
};


export type MutationCreateAiThreadReplyArgs = {
  input: CreateAiThreadReplyInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateReactionArgs = {
  input: CreateReactionInput;
};


export type MutationCreateUserSecretArgs = {
  input: CreateUserSecretInput;
};


export type MutationDeleteAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMessageArgs = {
  input: DeleteMessageInput;
};


export type MutationDeleteOAuthConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePromptArgs = {
  input: DeletePromptInput;
};


export type MutationDeleteReactionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUploadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExecuteAgentCronArgs = {
  input?: InputMaybe<ExecuteAgentCronInput>;
};


export type MutationExecuteProcessorArgs = {
  input: ExecuteProcessorInput;
};


export type MutationGeneratePromptTemplatesArgs = {
  input: GeneratePromptTemplatesInput;
};


export type MutationGenerateTemplatesArgs = {
  input: GenerateTemplatesInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationProcessMessageReactionArgs = {
  input: ProcessMessageReactionInput;
};


export type MutationQueueExecuteProcessorArgs = {
  input: ExecuteProcessorInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRenameUploadArgs = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRunAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationTestGmailConnectionArgs = {
  connectionId: Scalars['ID']['input'];
};


export type MutationToggleMessageReactionArgs = {
  input: ToggleMessageReactionInput;
};


export type MutationTranscribeAudioArgs = {
  input: TranscribeAudioInput;
};


export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


export type MutationUpdateMyUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationUpdateOAuthConnectionArgs = {
  input: UpdateOAuthConnectionInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserSecretArgs = {
  input: UpdateUserSecretInput;
};


export type MutationUpsertAgentArgs = {
  input: UpsertAgentInput;
};


export type MutationUpsertDocumentArgs = {
  input: UpsertDocumentInput;
};


export type MutationUpsertProcessorArgs = {
  input: UpsertProcessorInput;
};


export type MutationUpsertPromptArgs = {
  input: UpsertPromptInput;
};

/** Third-party account provider (Gmail today; more later) */
export enum OAuthProvider {
  Gmail = 'GMAIL'
}

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  /** Whether there are more items available */
  hasMore: Scalars['Boolean']['output'];
  /** Cursor for the next page (null if no more items) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Total count of items (optional, can be expensive to compute) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProcessMessageReactionInput = {
  /** Message whose reaction changed */
  messageId: Scalars['String']['input'];
  /** Whether the reaction was added or removed */
  operation: MessageReactionOperation;
  /** Reaction id from the reactions catalog */
  reactionId: Scalars['String']['input'];
  /** User id who added or removed the reaction (must match caller) */
  reactorUserId: Scalars['String']['input'];
};

export type ProcessMessageReactionResponse = {
  __typename?: 'ProcessMessageReactionResponse';
  /** Error message if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Status or error detail */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type Processor = {
  __typename?: 'Processor';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the ProcessorFile that holds the main script (and any prepended files via ProcessorFileMap) */
  fileId: Scalars['String']['output'];
  /** Machine-readable identifier */
  id: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProcessorDetail = {
  __typename?: 'ProcessorDetail';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the ProcessorFile that holds the main script (prepended files map to this parent) */
  fileId: Scalars['String']['output'];
  /** Ordered file segments for this processor (no source text; load code per file via processorFile) */
  fileRefs: Array<ProcessorFileRef>;
  /** Machine-readable identifier */
  id: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProcessorFileContent = {
  __typename?: 'ProcessorFileContent';
  /** Source text stored for this file */
  code: Scalars['String']['output'];
  /** ProcessorFile id */
  id: Scalars['String']['output'];
};

export type ProcessorFileRef = {
  __typename?: 'ProcessorFileRef';
  /** ProcessorFile id */
  id: Scalars['String']['output'];
  /** Prepended fragment vs main script file */
  role: ProcessorFileRole;
  /** Order key: lower prepended files run first; main segment is last */
  sortOrder: Scalars['Int']['output'];
};

export enum ProcessorFileRole {
  Main = 'MAIN',
  Prepended = 'PREPENDED'
}

export type ProcessorInstance = {
  __typename?: 'ProcessorInstance';
  /** AI audit rows for this processor run (metadata.instanceId or legacy metadata.executionId) */
  aiAudits: Array<AiAuditSummary>;
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Error message when the run failed */
  error?: Maybe<Scalars['String']['output']>;
  /** CUID of the processor run row */
  id: Scalars['String']['output'];
  /** Optional JSON metadata for processor execution */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Processor id that was executed */
  processorId: Scalars['String']['output'];
  /** True when a private run log object exists for this instance (readable via authenticated HTTP) */
  runLogAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** QUEUED before worker runs, RUNNING during execution, DONE when finished */
  status: ProcessorInstanceStatus;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Owning user id */
  userId: Scalars['String']['output'];
  /** JSON result after successful completion */
  value?: Maybe<Scalars['JSON']['output']>;
};


export type ProcessorInstanceAiAuditsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProcessorInstanceStatus {
  Done = 'DONE',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type PromptDefinition = {
  __typename?: 'PromptDefinition';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Name/identifier of the prompt */
  id: Scalars['String']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Content of the prompt */
  value: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  agent?: Maybe<Agent>;
  agents: GetAgentsResponse;
  /** Distinct endpoint and metadata.processorId values for AI audit filters (includes legacy metadata.prompt) */
  aiAuditFilterOptions: AiAuditFilterOptions;
  /** Recent AI audit rows (newest first); optional filters on endpoint and processorId */
  aiAudits: Array<AiAuditSummary>;
  /** Application settings (e.g. validation patterns for the client) */
  appSettings: AppSettings;
  document: DocumentResult;
  documentByPath: DocumentResult;
  documentHistory?: Maybe<DocumentHistory>;
  documents: Array<Document>;
  /** Current user from JWT cookie. Returns null if not authenticated. */
  me?: Maybe<AuthUser>;
  /** Reactors for a message reaction (display name with user id fallback) */
  messageReactionReactors: Array<MessageReactionReactor>;
  messages: Array<Message>;
  /** OAuth-linked accounts for the signed-in user */
  myOAuthConnections: Array<UserOAuthConnection>;
  /** Secrets for the signed-in user (values are ciphertext) */
  myUserSecrets: Array<UserSecret>;
  processor?: Maybe<ProcessorDetail>;
  processorFile?: Maybe<ProcessorFileContent>;
  /** Processor run row by id for the current user, or null if not found */
  processorInstance?: Maybe<ProcessorInstance>;
  /** Processor run rows for the current user (newest first). When processorId is set, only that processor; when omitted, all runs for the user */
  processorInstances: Array<ProcessorInstance>;
  /** Processor run rows for the current user where instance metadata.agentId matches (e.g. agent-triggered runs) */
  processorInstancesByAgent: Array<ProcessorInstance>;
  processors: GetProcessorsResponse;
  prompts: GetPromptsResponse;
  /** All reaction definitions (id → emoji), for pickers and labels */
  reactions: Array<Reaction>;
  /** Search users by username using case-insensitive partial matching. */
  searchUsersByUserName: Array<MentionUser>;
  /** Recent uploads for the signed-in user (newest first), from POST /api/upload */
  uploads: Array<UserUpload>;
  /** Uploads linked to a document (newest first). Empty when the document is missing or not owned by the caller. */
  uploadsForDocument: Array<UserUpload>;
};


export type QueryAgentArgs = {
  id: Scalars['String']['input'];
};


export type QueryAiAuditsArgs = {
  endpoint?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  processorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocumentByPathArgs = {
  path: Scalars['String']['input'];
};


export type QueryDocumentHistoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMessageReactionReactorsArgs = {
  messageId: Scalars['String']['input'];
  reactionId: Scalars['String']['input'];
};


export type QueryMessagesArgs = {
  input?: InputMaybe<MessagesQueryInput>;
};


export type QueryProcessorArgs = {
  id: Scalars['String']['input'];
};


export type QueryProcessorFileArgs = {
  id: Scalars['String']['input'];
};


export type QueryProcessorInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryProcessorInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  processorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProcessorInstancesByAgentArgs = {
  agentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchUsersByUserNameArgs = {
  query: Scalars['String']['input'];
};


export type QueryUploadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUploadsForDocumentArgs = {
  documentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueueExecuteProcessorResponse = {
  __typename?: 'QueueExecuteProcessorResponse';
  /** Human-readable detail (e.g. missing Bearer token, or error message when queued is false) */
  message?: Maybe<Scalars['String']['output']>;
  /** ProcessorInstance id for this queued run (pending until the worker executes) */
  processorInstanceId?: Maybe<Scalars['String']['output']>;
  /** Whether the task was queued (Cloud Tasks or local HTTP simulator when GRAPHQL_TASK_SIMULATOR_URL is set) */
  queued: Scalars['Boolean']['output'];
  /** Cloud Task resource name, or task id from GRAPHQL_TASK_SIMULATOR_URL */
  taskName?: Maybe<Scalars['String']['output']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  /** Stable reaction key (Slack-style), e.g. joy, thumbsup */
  id: Scalars['String']['output'];
  /** Display emoji for this reaction */
  value: Scalars['String']['output'];
};

export type RegisterInput = {
  /** User email */
  email: Scalars['String']['input'];
  /** Password (min 8 characters) */
  password: Scalars['String']['input'];
};

export type RunAgentResponse = {
  __typename?: 'RunAgentResponse';
  /** Agent row after a successful queue (lastRunAt updated) */
  agent?: Maybe<Agent>;
  message?: Maybe<Scalars['String']['output']>;
  queued: Scalars['Boolean']['output'];
  /** Cloud Task resource name, or task id from GRAPHQL_TASK_SIMULATOR_URL */
  taskName?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  documentUpdated: DocumentUpdatedPayload;
  inboxMessagesUpdated: MessageThreadUpdatedPayload;
  messageThreadUpdated: MessageThreadUpdatedPayload;
};


export type SubscriptionDocumentUpdatedArgs = {
  path: Scalars['String']['input'];
};


export type SubscriptionMessageThreadUpdatedArgs = {
  threadRootId: Scalars['String']['input'];
};

export type ToggleMessageReactionInput = {
  /** Message to add or remove a reaction on */
  messageId: Scalars['String']['input'];
  /** Reaction id from the reactions catalog */
  reactionId: Scalars['String']['input'];
};

export type TranscribeAudioInput = {
  /** Array of file names to transcribe */
  fileNames: Array<Scalars['String']['input']>;
};

export type TranscribeAudioResponse = {
  __typename?: 'TranscribeAudioResponse';
  /** Number of files that failed transcription */
  failureCount: Scalars['Float']['output'];
  /** Response message */
  message: Scalars['String']['output'];
  /** Results for each file processed */
  results: Array<TranscribeResult>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Number of files successfully transcribed */
  successCount: Scalars['Float']['output'];
};

export type TranscribeResult = {
  __typename?: 'TranscribeResult';
  /** Error message if failed */
  error?: Maybe<Scalars['String']['output']>;
  /** File name that was processed */
  fileName: Scalars['String']['output'];
  /** File path that was processed */
  filePath: Scalars['String']['output'];
  /** Whether transcription was successful */
  success: Scalars['Boolean']['output'];
  /** Transcription content if successful */
  transcription?: Maybe<Scalars['String']['output']>;
};

export type UpdateMessageInput = {
  /** ID of the message to update */
  id: Scalars['String']['input'];
  /** New message body */
  value: Scalars['String']['input'];
};

export type UpdateOAuthConnectionInput = {
  /** New description (trimmed, max 500) */
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateUserProfileInput = {
  /** Display name shown in the UI */
  displayName: Scalars['String']['input'];
  /** Optional unique user name shown in settings and profile UI */
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserSecretInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  /** When set, replaces stored ciphertext with a new encryption */
  plaintextValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserSettingsInput = {
  /** Set preferred AI model id, or null to clear and use deployment default */
  aiAssistEditChatModel?: InputMaybe<Scalars['String']['input']>;
  /** Set light or dark theme, or null to clear (default light) */
  colorMode?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertAgentInput = {
  /** Cron schedule expression (host interprets when firing) */
  cron: Scalars['String']['input'];
  /** Defaults to true when creating */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Existing agent id to update; omit to create a new agent */
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Processor variables (e.g. documentId, instructions; optional allowlisted model for agent-edit-document) */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  processorId: Scalars['String']['input'];
};

export type UpsertAgentResponse = {
  __typename?: 'UpsertAgentResponse';
  agent: Agent;
  message: Scalars['String']['output'];
};

export type UpsertDocumentInput = {
  /** Context of the document (optional for updates) */
  context?: InputMaybe<Scalars['String']['input']>;
  /** Format of the document (optional for updates) */
  format?: InputMaybe<Scalars['String']['input']>;
  /** Structured format-specific metadata (optional for updates, e.g. markdown block sidecar state). */
  formatMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Format validation information for the document */
  formatValidation?: InputMaybe<Scalars['String']['input']>;
  /** ID of the document (cuid) - used for lookups and updates */
  id: Scalars['String']['input'];
  /** Path/name of the document (globally unique, required for new documents) */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Source ID for linking to messages or other entities */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Source type that caused this change (e.g., "user", "message") */
  sourceType?: InputMaybe<Scalars['String']['input']>;
  /** Content of the document (optional for updates) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDocumentResponse = {
  __typename?: 'UpsertDocumentResponse';
  /** The upserted document */
  document: Document;
  /** Server-established edit time for this mutation */
  documentMetadata: DocumentMetadata;
  /** Whether the document was created (true) or updated (false) */
  wasCreated: Scalars['Boolean']['output'];
};

export type UpsertProcessorInput = {
  /** ID of the ProcessorFile to run (must exist) */
  fileId: Scalars['String']['input'];
  /** Machine-readable identifier (no default) */
  id: Scalars['String']['input'];
};

export type UpsertProcessorResponse = {
  __typename?: 'UpsertProcessorResponse';
  /** Response message */
  message: Scalars['String']['output'];
  /** The upserted processor */
  processor: Processor;
};

export type UpsertPromptInput = {
  /** ID/name of the prompt */
  id: Scalars['String']['input'];
  /** Content of the prompt */
  value: Scalars['String']['input'];
};

export type UpsertPromptResponse = {
  __typename?: 'UpsertPromptResponse';
  /** Response message */
  message: Scalars['String']['output'];
  /** The upserted prompt definition */
  promptDefinition: PromptDefinition;
};

/** Linked OAuth account for the signed-in user (tokens are never exposed) */
export type UserOAuthConnection = {
  __typename?: 'UserOAuthConnection';
  createdAt: Scalars['DateTime']['output'];
  /** User-editable label for this connection */
  description: Scalars['String']['output'];
  /** CUID of this connection row */
  id: Scalars['ID']['output'];
  /** Non-secret display metadata (e.g. email, name) */
  metadata?: Maybe<Scalars['JSON']['output']>;
  provider: OAuthProvider;
  /** Stable provider account id (e.g. Google `sub`) */
  providerAccountId: Scalars['String']['output'];
  /** Granted OAuth scopes */
  scopes: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-user secret; value is ciphertext (npfe wire format) */
export type UserSecret = {
  __typename?: 'UserSecret';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** SHA-256 fingerprint of the encryption key used */
  encryptKeyHash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** User-defined secret name (unique per user) */
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Encrypted value (wire string from CryptoService) */
  value: Scalars['String']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  /** Preferred OpenAI chat model for document AI (executeProcessor); must be in appSettings.aiAssistEditChatModels when set. */
  aiAssistEditChatModel?: Maybe<Scalars['String']['output']>;
  /** Light or dark UI theme; null means default (light). */
  colorMode?: Maybe<Scalars['String']['output']>;
};

/** A file uploaded via POST /api/upload for the current user */
export type UserUpload = {
  __typename?: 'UserUpload';
  createdAt: Scalars['DateTime']['output'];
  /** Document this upload is linked to, if any */
  documentId?: Maybe<Scalars['String']['output']>;
  /** Path of the linked document, if any */
  documentPath?: Maybe<Scalars['String']['output']>;
  /** True for POST /api/upload?draft=true until the upload is linked by createMessage */
  draft: Scalars['Boolean']['output'];
  /** Original filename from the upload */
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** True when the object in user-assets is ciphertext (use GET /api/upload/:id to view) */
  isEncrypted: Scalars['Boolean']['output'];
  /** Object key in the user-assets bucket (userId/uuid.ext) */
  resourceId: Scalars['String']['output'];
  /** HTTPS URL to fetch the uploaded object */
  url: Scalars['String']['output'];
};

export type MessageFieldsFragment = { __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> };

export type CreateAiThreadReplyMutationVariables = Exact<{
  input: CreateAiThreadReplyInput;
}>;


export type CreateAiThreadReplyMutation = { __typename?: 'Mutation', createAiThreadReply: { __typename?: 'Message', id: string } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, childMessages: Array<{ __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> }>, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> } };

export type CreateReactionMutationVariables = Exact<{
  input: CreateReactionInput;
}>;


export type CreateReactionMutation = { __typename?: 'Mutation', createReaction: { __typename?: 'Reaction', id: string, value: string } };

export type CreateUserSecretMutationVariables = Exact<{
  input: CreateUserSecretInput;
}>;


export type CreateUserSecretMutation = { __typename?: 'Mutation', createUserSecret: { __typename?: 'UserSecret', id: string, key: string, description: string, createdAt: any, updatedAt: any } };

export type DeleteAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAgentMutation = { __typename?: 'Mutation', deleteAgent: { __typename?: 'DeleteAgentResponse', deleted: boolean, message?: string | null } };

export type DeleteMessageMutationVariables = Exact<{
  input: DeleteMessageInput;
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: { __typename?: 'Message', id: string } };

export type DeleteOAuthConnectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOAuthConnectionMutation = { __typename?: 'Mutation', deleteOAuthConnection: boolean };

export type DeletePromptMutationVariables = Exact<{
  input: DeletePromptInput;
}>;


export type DeletePromptMutation = { __typename?: 'Mutation', deletePrompt: { __typename?: 'DeletePromptResponse', message: string, success: boolean } };

export type DeleteReactionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteReactionMutation = { __typename?: 'Mutation', deleteReaction: boolean };

export type DeleteUploadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUploadMutation = { __typename?: 'Mutation', deleteUpload: boolean };

export type DeleteUserSecretMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserSecretMutation = { __typename?: 'Mutation', deleteUserSecret: boolean };

export type ExecuteProcessorMutationVariables = Exact<{
  input: ExecuteProcessorInput;
}>;


export type ExecuteProcessorMutation = { __typename?: 'Mutation', executeProcessor: { __typename?: 'ExecuteProcessorResponse', success: boolean, error?: string | null, result?: any | null, instanceId?: string | null } };

export type GeneratePromptTemplatesMutationVariables = Exact<{
  input: GeneratePromptTemplatesInput;
}>;


export type GeneratePromptTemplatesMutation = { __typename?: 'Mutation', generatePromptTemplates: { __typename?: 'GenerateTemplatesResponse', results: Array<{ __typename?: 'GenerateTemplateResponse', result: string, success: boolean, error?: string | null }> } };

export type GenerateTemplatesMutationVariables = Exact<{
  input: GenerateTemplatesInput;
}>;


export type GenerateTemplatesMutation = { __typename?: 'Mutation', generateTemplates: { __typename?: 'GenerateTemplatesResponse', results: Array<{ __typename?: 'GenerateTemplateResponse', result: string, success: boolean, error?: string | null }> } };

export type RefreshAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshAccessToken: { __typename?: 'AuthPayload', user: { __typename?: 'AuthUser', id: string, email: string } } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', user: { __typename?: 'AuthUser', id: string, email: string } } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'AuthPayload', user: { __typename?: 'AuthUser', id: string, email: string } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };

export type RenameUploadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
}>;


export type RenameUploadMutation = { __typename?: 'Mutation', renameUpload: { __typename?: 'UserUpload', id: string, resourceId: string, filename?: string | null, createdAt: any, documentId?: string | null, documentPath?: string | null, url: string, isEncrypted: boolean, draft: boolean } };

export type RunAgentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RunAgentMutation = { __typename?: 'Mutation', runAgent: { __typename?: 'RunAgentResponse', queued: boolean, message?: string | null, taskName?: string | null, agent?: { __typename?: 'Agent', id: string, lastRunAt?: any | null, updatedAt: any } | null } };

export type TestGmailConnectionMutationVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type TestGmailConnectionMutation = { __typename?: 'Mutation', testGmailConnection: { __typename?: 'GmailConnectionTestResult', success: boolean, errorMessage?: string | null, subjects: Array<string>, fetchedCount: number, resultSizeEstimate?: number | null } };

export type ToggleMessageReactionMutationVariables = Exact<{
  input: ToggleMessageReactionInput;
}>;


export type ToggleMessageReactionMutation = { __typename?: 'Mutation', toggleMessageReaction: { __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> } };

export type UpdateMessageMutationVariables = Exact<{
  input: UpdateMessageInput;
}>;


export type UpdateMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> } };

export type UpdateMyUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateMyUserSettingsMutation = { __typename?: 'Mutation', updateMyUserSettings: { __typename?: 'AuthUser', id: string, email: string, effectiveAiAssistEditChatModel: string, settings?: { __typename?: 'UserSettings', aiAssistEditChatModel?: string | null, colorMode?: string | null } | null } };

export type UpdateOAuthConnectionMutationVariables = Exact<{
  input: UpdateOAuthConnectionInput;
}>;


export type UpdateOAuthConnectionMutation = { __typename?: 'Mutation', updateOAuthConnection: { __typename?: 'UserOAuthConnection', id: string, provider: OAuthProvider, providerAccountId: string, description: string, metadata?: any | null, scopes: string, createdAt: any, updatedAt: any } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'AuthUser', id: string, email: string, displayName: string, userName?: string | null, effectiveAiAssistEditChatModel: string, settings?: { __typename?: 'UserSettings', aiAssistEditChatModel?: string | null, colorMode?: string | null } | null } };

export type UpdateUserSecretMutationVariables = Exact<{
  input: UpdateUserSecretInput;
}>;


export type UpdateUserSecretMutation = { __typename?: 'Mutation', updateUserSecret: { __typename?: 'UserSecret', id: string, key: string, description: string, createdAt: any, updatedAt: any } };

export type UpsertAgentMutationVariables = Exact<{
  input: UpsertAgentInput;
}>;


export type UpsertAgentMutation = { __typename?: 'Mutation', upsertAgent: { __typename?: 'UpsertAgentResponse', message: string, agent: { __typename?: 'Agent', id: string, userId: string, name: string, cron: string, processorId: string, parameters: any, enabled: boolean, createdAt: any, updatedAt: any } } };

export type UpsertDocumentMutationVariables = Exact<{
  input: UpsertDocumentInput;
}>;


export type UpsertDocumentMutation = { __typename?: 'Mutation', upsertDocument: { __typename?: 'UpsertDocumentResponse', wasCreated: boolean, document: { __typename?: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatMetadata?: any | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, changedByUserId?: string | null, createdAt: any, changedBy?: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string } | null }> }, documentMetadata: { __typename?: 'DocumentMetadata', editTimestamp: number } } };

export type UpsertPromptMutationVariables = Exact<{
  input: UpsertPromptInput;
}>;


export type UpsertPromptMutation = { __typename?: 'Mutation', upsertPrompt: { __typename?: 'UpsertPromptResponse', message: string, promptDefinition: { __typename?: 'PromptDefinition', id: string, value: string, createdAt: any, updatedAt: any } } };

export type GetAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsQuery = { __typename?: 'Query', agents: { __typename?: 'GetAgentsResponse', agents: Array<{ __typename?: 'Agent', id: string, userId: string, name: string, cron: string, processorId: string, parameters: any, enabled: boolean, lastRunAt?: any | null, createdAt: any, updatedAt: any }> } };

export type GetAgentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAgentQuery = { __typename?: 'Query', agent?: { __typename?: 'Agent', id: string, userId: string, name: string, cron: string, processorId: string, parameters: any, enabled: boolean, lastRunAt?: any | null, createdAt: any, updatedAt: any } | null };

export type GetAiAuditsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  processorId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAiAuditsQuery = { __typename?: 'Query', aiAudits: Array<{ __typename?: 'AiAuditSummary', id: string, createdAt: any, endpoint: string, metadata?: any | null, processorId?: string | null, iteration?: number | null, maxIterations?: number | null, model?: string | null, instanceId?: string | null, tokenIn?: number | null, tokenOut?: number | null }> };

export type GetAiAuditFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiAuditFilterOptionsQuery = { __typename?: 'Query', aiAuditFilterOptions: { __typename?: 'AiAuditFilterOptions', endpoints: Array<string>, processorIds: Array<string> } };

export type GetAppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppSettingsQuery = { __typename?: 'Query', appSettings: { __typename?: 'AppSettings', documentPathRegex: string, localEndpoints?: boolean | null, localDatabase?: boolean | null, localGraphqlTaskSimulator?: boolean | null, aiAssistEditChatModels: Array<string>, defaultAiAssistEditChatModel: string } };

export type DocumentPickerListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentPickerListQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, path: string }> };

export type GetUploadsForDocumentQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUploadsForDocumentQuery = { __typename?: 'Query', uploadsForDocument: Array<{ __typename?: 'UserUpload', id: string, resourceId: string, filename?: string | null, createdAt: any, documentId?: string | null, documentPath?: string | null, url: string, isEncrypted: boolean, draft: boolean }> };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', document: { __typename: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatMetadata?: any | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, changedByUserId?: string | null, createdAt: any, changedBy?: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string } | null }> } | { __typename: 'DocumentNotFound', requestedPath?: string | null } };

export type GetDocumentByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type GetDocumentByPathQuery = { __typename?: 'Query', documentByPath: { __typename: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatMetadata?: any | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, changedByUserId?: string | null, createdAt: any, changedBy?: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string } | null }>, children: { __typename?: 'DocumentChildrenResponse', items: Array<{ __typename?: 'Document', id: string, path: string }>, pagination: { __typename?: 'PaginationInfo', hasMore: boolean } } } | { __typename: 'DocumentNotFound', requestedPath?: string | null, parent?: { __typename?: 'Document', id: string, path: string } | null, children: { __typename?: 'DocumentChildrenResponse', items: Array<{ __typename?: 'Document', id: string, path: string }>, pagination: { __typename?: 'PaginationInfo', hasMore: boolean } } } };

export type GetDocumentHistoryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDocumentHistoryQuery = { __typename?: 'Query', documentHistory?: { __typename?: 'DocumentHistory', id: string, value: any, documentId: string, changedByUserId?: string | null, createdAt: any, changedBy?: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string } | null } | null };

export type GetDocumentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, path: string, userId: string, context?: string | null, value: string, format?: string | null, formatMetadata?: any | null, formatValidation?: string | null, createdAt: any, updatedAt: any, documentHistory: Array<{ __typename?: 'DocumentHistory', id: string, value: any, documentId: string, changedByUserId?: string | null, createdAt: any, changedBy?: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string } | null }> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'AuthUser', id: string, email: string, displayName: string, userName?: string | null, effectiveAiAssistEditChatModel: string, settings?: { __typename?: 'UserSettings', aiAssistEditChatModel?: string | null, colorMode?: string | null } | null } | null };

export type MessageReactionReactorsQueryVariables = Exact<{
  messageId: Scalars['String']['input'];
  reactionId: Scalars['String']['input'];
}>;


export type MessageReactionReactorsQuery = { __typename?: 'Query', messageReactionReactors: Array<{ __typename?: 'MessageReactionReactor', userId: string, displayName: string, gravatarHash?: string | null }> };

export type GetMessagesQueryVariables = Exact<{
  input?: InputMaybe<MessagesQueryInput>;
}>;


export type GetMessagesQuery = { __typename?: 'Query', messages: Array<{ __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, childMessages: Array<{ __typename?: 'Message', id: string, value: string, source: string, sourceId?: string | null, createdAt: any, updatedAt: any, userId: string, targetUserId: string, parentMessageId?: string | null, reactions: any, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> }>, author: { __typename?: 'MessageAuthor', displayName: string, gravatarHash: string }, messageContexts: Array<{ __typename?: 'MessageContext', name: string, value: string, document?: { __typename?: 'Document', id: string, path: string } | null }> }> };

export type MyOAuthConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOAuthConnectionsQuery = { __typename?: 'Query', myOAuthConnections: Array<{ __typename?: 'UserOAuthConnection', id: string, provider: OAuthProvider, providerAccountId: string, description: string, metadata?: any | null, scopes: string, createdAt: any, updatedAt: any }> };

export type MyUserSecretsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUserSecretsQuery = { __typename?: 'Query', myUserSecrets: Array<{ __typename?: 'UserSecret', id: string, key: string, value: string, encryptKeyHash: string, description: string, createdAt: any, updatedAt: any }> };

export type GetProcessorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProcessorQuery = { __typename?: 'Query', processor?: { __typename?: 'ProcessorDetail', id: string, fileId: string, createdAt: any, updatedAt: any, fileRefs: Array<{ __typename?: 'ProcessorFileRef', id: string, sortOrder: number, role: ProcessorFileRole }> } | null };

export type GetProcessorFileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProcessorFileQuery = { __typename?: 'Query', processorFile?: { __typename?: 'ProcessorFileContent', id: string, code: string } | null };

export type GetProcessorInstanceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProcessorInstanceQuery = { __typename?: 'Query', processorInstance?: { __typename?: 'ProcessorInstance', id: string, processorId: string, userId: string, status: ProcessorInstanceStatus, runLogAvailable?: boolean | null, metadata?: any | null, error?: string | null, createdAt: any, updatedAt: any, aiAudits: Array<{ __typename?: 'AiAuditSummary', id: string, createdAt: any, endpoint: string, metadata?: any | null, processorId?: string | null, iteration?: number | null, maxIterations?: number | null, model?: string | null, instanceId?: string | null, tokenIn?: number | null, tokenOut?: number | null }> } | null };

export type GetProcessorInstancesByAgentQueryVariables = Exact<{
  agentId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProcessorInstancesByAgentQuery = { __typename?: 'Query', processorInstancesByAgent: Array<{ __typename?: 'ProcessorInstance', id: string, processorId: string, userId: string, status: ProcessorInstanceStatus, runLogAvailable?: boolean | null, metadata?: any | null, error?: string | null, createdAt: any, updatedAt: any }> };

export type GetProcessorInstancesByProcessorQueryVariables = Exact<{
  processorId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProcessorInstancesByProcessorQuery = { __typename?: 'Query', processorInstances: Array<{ __typename?: 'ProcessorInstance', id: string, processorId: string, userId: string, status: ProcessorInstanceStatus, metadata?: any | null, error?: string | null, createdAt: any, updatedAt: any }> };

export type GetProcessorInstancesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProcessorInstancesQuery = { __typename?: 'Query', processorInstances: Array<{ __typename?: 'ProcessorInstance', id: string, processorId: string, userId: string, status: ProcessorInstanceStatus, metadata?: any | null, error?: string | null, createdAt: any, updatedAt: any }> };

export type GetProcessorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProcessorsQuery = { __typename?: 'Query', processors: { __typename?: 'GetProcessorsResponse', processors: Array<{ __typename?: 'Processor', id: string, fileId: string, createdAt: any, updatedAt: any }> } };

export type GetPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromptsQuery = { __typename?: 'Query', prompts: { __typename?: 'GetPromptsResponse', prompts: Array<{ __typename?: 'PromptDefinition', id: string, value: string, createdAt: any, updatedAt: any }> } };

export type GetReactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReactionsQuery = { __typename?: 'Query', reactions: Array<{ __typename?: 'Reaction', id: string, value: string }> };

export type SearchUsersByUserNameQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchUsersByUserNameQuery = { __typename?: 'Query', searchUsersByUserName: Array<{ __typename?: 'MentionUser', id: string, userName: string, displayName: string }> };

export type GetUploadsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUploadsQuery = { __typename?: 'Query', uploads: Array<{ __typename?: 'UserUpload', id: string, resourceId: string, filename?: string | null, createdAt: any, documentId?: string | null, documentPath?: string | null, url: string, isEncrypted: boolean, draft: boolean }> };

export type DocumentUpdatedSubscriptionVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type DocumentUpdatedSubscription = { __typename?: 'Subscription', documentUpdated: { __typename?: 'DocumentUpdatedPayload', documentId: string, path: string, ownerUserId: string, updatedAt: any, editTimestamp: number } };

export type InboxMessagesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InboxMessagesUpdatedSubscription = { __typename?: 'Subscription', inboxMessagesUpdated: { __typename?: 'MessageThreadUpdatedPayload', threadRootId: string, participantUserIds: Array<string> } };
